module.exports = __webpack_public_path__ + "static/assets/3826023814dccff264050d454d7d8cbd.png";